import { useState } from "react";
import { api, apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const EMPTY = { nome: "", cognome: "", email: "", telefono: "", messaggio: "", segnalato_da: "", consenso_privacy: false };

// Richiesta di consulenza dedicata (o segnalazione "Presenta un collega" con tipo="referral").
export const ConsulenzaDialog = ({ open, onOpenChange, codice, slug, product, productLabel, tipo = "consulenza" }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const invia = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/public/accordi/consulenza", { ...f, codice, slug, product, tipo });
      toast.success(data.message);
      setF(EMPTY); onOpenChange(false);
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="consulenza-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-forest">{tipo === "referral" ? "Presenta un collega" : "Richiedi una consulenza dedicata"}</DialogTitle>
          <DialogDescription>{tipo === "referral" ? "Indica i dati del collega: lo ricontatterà un consulente con le condizioni dell'accordo." : `${productLabel ? `Prodotto: ${productLabel}. ` : ""}Ti ricontatta un consulente Assietica dedicato al tuo accordo.`}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {tipo === "referral" && <div className="space-y-1.5"><Label>Il tuo nome e cognome</Label><Input value={f.segnalato_da} onChange={set("segnalato_da")} data-testid="referral-segnalato-da" /></div>}
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Nome *</Label><Input value={f.nome} onChange={set("nome")} data-testid="consulenza-nome" /></div>
            <div className="space-y-1.5"><Label>Cognome *</Label><Input value={f.cognome} onChange={set("cognome")} data-testid="consulenza-cognome" /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Email *</Label><Input type="email" value={f.email} onChange={set("email")} data-testid="consulenza-email" /></div>
            <div className="space-y-1.5"><Label>Telefono</Label><Input value={f.telefono} onChange={set("telefono")} data-testid="consulenza-telefono" /></div>
          </div>
          <div className="space-y-1.5"><Label>Messaggio</Label><Textarea value={f.messaggio} onChange={set("messaggio")} data-testid="consulenza-messaggio" placeholder="Di cosa hai bisogno? (non indicare dati sanitari)" /></div>
          <label className="flex items-start gap-2 text-xs text-muted-foreground">
            <Checkbox checked={f.consenso_privacy} onCheckedChange={(v) => setF({ ...f, consenso_privacy: !!v })} data-testid="consulenza-privacy" />
            {tipo === "referral" ? "Confermo che il collega è d'accordo a essere contattato da Assietica per questa proposta (Reg. UE 2016/679)." : "Acconsento al trattamento dei dati per essere ricontattato (Reg. UE 2016/679)."}
          </label>
          <Button onClick={invia} disabled={busy || !f.nome || !f.cognome || !f.email || !f.consenso_privacy} data-testid="consulenza-invia" className="w-full bg-terracotta hover:bg-terracotta-hover">
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Invia richiesta
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
